import { inject } from "@angular/core";
import { map, catchError, of } from "rxjs";
import { UserService } from "../services/user.service";
import { StepControlService } from "../services/step-control.service";

/**
 * Guard que verifica se o usuário precisa fazer o onboarding
 * Se is_pending_onboarding = false OU se onboarding foi concluído no localStorage,
 * redireciona para a plataforma principal
 */
export const onboardingGuard = () => {
  const userService = inject(UserService);
  const stepControl = inject(StepControlService);

  const isOnboardingCompletedLocally = stepControl.isOnboardingCompleted();
  if (isOnboardingCompletedLocally) {
    const isLocalhost =
      window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
    const redirectUrl = isLocalhost ? "http://localhost:4200" : "https://app.yooga.com.br";
    window.location.href = redirectUrl;
    return of(false);
  }

  return userService.getAuthenticatedUser().pipe(
    map((user) => {
      const isPendingOnboarding = user.instalacao?.is_pending_onboarding ?? true;

      if (!isPendingOnboarding) {
        const isLocalhost =
          window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

        const redirectUrl = isLocalhost ? "http://localhost:4200" : "https://app.yooga.com.br";

        window.location.href = redirectUrl;
        return false;
      }

      return true;
    }),
    catchError(() => {
      return of(true);
    })
  );
};
